import {
  Button,
  CellFormatOptions,
  ColumnTable,
  Icon,
} from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  remove: (index: number) => void;
  canEdit?: boolean;
}

export function useColumns({ remove }: Props): ColumnTable[] {
  const { t } = useTranslation();
  const prefix = 'studyPlans.curriculum.degreeDocuments.table.headers';

  return useMemo(
    () => [
      {
        columnName: 'name',
        headerText: t(`${prefix}.name`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'code',
        headerText: t(`${prefix}.code`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'description',
        headerText: t(`${prefix}.description`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'action',
        headerText: t(`${prefix}.action`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (data: CellFormatOptions<any>) => {
          return (
            <button
              type="button"
              className="btn btn-primary bg-transparent border-0"
              onClick={() => remove(data.row.fieldId)}
            >
              <Icon size="15" name="trash" />
            </button>
          );
        },
      },
    ],
    [t],
  );
}
